import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CompanyClient,
    CustomReportCompanyView,
    EntityTypeCustomFieldDto,
    GetCompanyColumnChartValuesResultType,
    GetCompanyLineChartValuesResultType,
    GetCompanyMetricsValuesResultType,
    GetCompanyValuesParameters,
    GetCompanyValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingCompanyService extends CustomReportServiceBase<CompanyClient, CustomReportCompanyView> {
    constructor(protected override client: CompanyClient) {
        super(client);
    }

    async getCompanyBoxesValues(parameters: GetCompanyValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.companyGetCompanyBoxesValues(parameters));
    }

    async getCompanyColumnChartValues(
        parameters: GetCompanyValuesParameters
    ): Promise<GetCompanyColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.companyGetCompanyColumnChartValues(parameters));
    }

    async getCompanyLineChartValues(
        parameters: GetCompanyValuesParameters
    ): Promise<GetCompanyLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.companyGetCompanyLineChartValues(parameters));
    }

    async getCompanyMetricsValues(parameters: GetCompanyValuesParameters): Promise<GetCompanyMetricsValuesResultType> {
        return await lastValueFrom(this.client.companyGetCompanyMetricsValues(parameters));
    }

    async getCompanyValues(parameters: GetCompanyValuesParameters): Promise<GetCompanyValuesResultType[]> {
        return await lastValueFrom(this.client.companyGetCompanyValues(parameters));
    }
    override async saveCustomReport(body: CustomReportCompanyView): Promise<CustomReportCompanyView> {
        if (body.isPublic) return await lastValueFrom(this.client.companySaveCatalogReport(body));
        else return await lastValueFrom(this.client.companySaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportCompanyView> {
        return await lastValueFrom(this.client.companyGetCustomReport(id));
    }

    override async shareReport(body: CustomReportCompanyView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.companyCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportCompanyView> {
        return await lastValueFrom(this.client.companyGetSharedReport(id));
    }

    async getCustomFieldColumns(organizationIds: number[]): Promise<EntityTypeCustomFieldDto[]> {
        return await lastValueFrom(this.client.companyGetCustomFieldColumns(organizationIds));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.companyResultAvailableColumns(organizationIds));
    }
}
